import { z } from "zod";
import { API_ERROR_CODES, type ApiErrorCode } from "./errors";

/** `{ data, meta }` for a single resource. `meta` is reserved for request-level info. */
export function dataEnvelope<T extends z.ZodTypeAny>(data: T) {
  return z.object({ data, meta: z.object({}).catchall(z.unknown()) });
}

/** `{ data: [...], meta: { next_cursor } }` for a list. */
export function listEnvelope<T extends z.ZodTypeAny>(item: T, extraMeta: z.ZodRawShape = {}) {
  return z.object({
    data: z.array(item),
    meta: z.object({ next_cursor: z.string().nullable(), ...extraMeta }),
  });
}

const codes = Object.keys(API_ERROR_CODES) as [ApiErrorCode, ...ApiErrorCode[]];

export const errorEnvelope = z.object({
  error: z.object({
    code: z.enum(codes),
    message: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
  }),
});
export type ErrorEnvelope = z.infer<typeof errorEnvelope>;
